import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader, TrueFalseRadio } from "../../../../NewBusinessWizard/Components/SharedComponents";
import { AccountName } from "./AccountName";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { EWizardLinterStatus, WizardLinter } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../Resource/EWizardLinterHelper";
import { QuoteAndApplyBaseModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/QuoteAndApplyBaseModel";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";

interface IPPSectionProps extends IProcessComponentProps {
    data: QuoteAndApplyBaseModel;
}

interface IPPSectionState {
    customeChildren: JSX.Element;
}

export class PPSection extends ProcessComponent<IPPSectionProps, IPPSectionState> {
    constructor(props: any) {
        super(props);
    }

    getBlockStatus(data): EWizardLinterStatus {
        const complete = data?.IsAddRegularWithdrawalSelected != null;
        return EWizardLinterHelper.getEWizardLinterStatus(complete);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const productIndex = data.SelectedProducts.findIndex(
            (e) => e.SubAccountType == SubAccountType.InvestmentAccount
        );

        const Product = data.SelectedProducts[productIndex];
        return (
            <WizardLinter
                status={this.getBlockStatus(Product)}
                enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.InvestmentAccount)}
            >
                {SectionHeader("Personal Portfolio options")}
                {TrueFalseRadio(
                    "Will your client be taking regular withdrawals?",
                    "IsAddRegularWithdrawalSelected",
                    Product,
                    (key, value) => {
                        this.onProductChange({ [key]: value }, Product, productIndex);
                    },
                    true,
                    { cssWrapper: "radio-group rg-inline rg-150 mb-16" }
                )}

                <AccountName
                    data={Product}
                    AccountName={"Personal Portfolio account name"}
                    onRef={(ref) => this.appendChild(ref)}
                    onChange={(AccountNameGiven) => {
                        this.onAccountNameChange(AccountNameGiven, Product, productIndex);
                    }}
                />

                <hr className="mb-26" />
            </WizardLinter>
        );
    }

    private onProductChange(changes, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        for (const key in changes) {
            _product[key] = changes[key];
        }
        const data = this.props.data.SelectedProducts.concat();
        data[index] = _product;
        this.props.onChange({
            SelectedProducts: data,
            GiaModel:
                changes?.IsAddRegularWithdrawalSelected == false
                    ? { ...(this.props.data as ApplyModel).GiaModel, RegularWithdrawalModel: [] }
                    : (this.props.data as ApplyModel).GiaModel,
        });
    }

    private onAccountNameChange(AccountNameGiven, product, index) {
        const _product = JSON.parse(JSON.stringify(product));
        if (_product.AccountNameGiven == undefined)
            {_product.AccountNameGiven = { HasAccountNameGiven: false, AccountNameGivenDetail: "" };}
        _product.AccountNameGiven = AccountNameGiven;
        const data = JSON.parse(JSON.stringify(this.props.data.SelectedProducts.concat()));
        data[index] = _product;
        this.props.onChange({ SelectedProducts: data });
    }
}
